<!-- Native-Angular port of account-v2/.../advocacy/group/big-picture/bigPicture.html.
     Inlines <ft-context-selector-link> as a span (QA login is single-property
     context, the only rendered branch). ft-loading-animation directive inlined as its
     rendered DOM: `.ft-loading-animation-dark` (60px centered margins) wrapping the
     Loading label + the `.ft2-spinner` ring — a bare div loses both the spacing under
     the tab strip and the spinner. ft-forward-click / ft-scroll-to dropped
     (scroll-anchor sugar, not visible content). -->
<ft-initialized-content [isInitialized]="isInitialized">
    <section class="ft-master-section ft-advocacy-bigpicture-master">
        <section class="ft-section ft-bigpicture-section">
            <div class="ft-container">
                <div class="mb-5">
                    <ft-daterange-picker (changed)="onCalendarDateRangeChange($event)" [storageKey]="'advocacy.bigpicture'" [pastDays]="7" />
                </div>
                <div class="ft-bigpicture-share">
                    <p class="ft-text-plus-2">
                        Through Advocacy, <span class="ft-emphasis">{{propertyAdvocacyOverview?.totalAdvocates | number}} travelers</span> shared their stories, helping <span>{{property?.Name}}</span> reach an audience of</p>
                </div>
                <div class="ft-bigpicture-reach">
                    <p class="ft-count ft-text-plus-9">{{propertyAdvocacyOverview?.socialConnections | number}}</p>
                    <p class="ft-count-label ft-text-plus-3">people worldwide</p>
                </div>

                <div class="ft-bigpicture-results">
                    <div class="ft-row">
                        <div class="ft-col-50">
                            <div class="ft-bigpicture-visitors">
                                <p class="ft-text-plus-1">Their personal introductions attracted</p>
                                <p class="ft-count ft-text-plus-7">{{propertyAdvocacyOverview?.totalVisitors | number}}</p>
                                <p class="ft-count-label ft-text-plus-2">
                                    unique visitors to your<br/>
                                    website experiences
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="ft-row">
                        <div class="ft-col-50 ft-col-right">
                            <div class="ft-bigpicture-leads">
                                <p class="ft-text-plus-1">And through rich experiences tailored for every visitor, your
                                    platform helped convert
                                </p>
                                <p class="ft-count ft-text-plus-7">{{propertyAdvocacyOverview?.totalSignups | number}}</p>
                                <p class="ft-count-label ft-text-plus-2">
                                    warm leads who showed<br/>
                                    genuine interest
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="ft-section ft-bookings-breakdown-section"
                 *ngIf="propertyAdvocacyOverview?.bookedNights > 0">
            <div class="ft-section-bg"></div>
            <div class="ft-content">
                <div class="ft-container">
                    <p class="ft-text-plus-2">During this
                        <span>{{endDate | daysUntilDate:startDate}}-day period</span>, at least
                        <span class="ft-emphasis">{{propertyAdvocacyOverview?.bookedNights | number}} room nights were
                            booked
                        </span>
                        that can be attributed to Advocacy.
                    </p>
                </div>
            </div>
        </section>

        <ft-sections #ftSecs [registry]="sectionsRegistry">
            <section class="ft-section ft-journey-breakdown-section">
                <div class="ft-container">
                    <p class="ft-heading ft-text-plus-2" *ngIf="hasAnyLayersActive()">This impact was made
                        through...
                    </p>
                    <div class="ft-nav ft-navbar ft-contexttabs-nav">
                        <ul>
                            <ng-container *ngFor="let section of sectionsRegistry">
                                <li *ngIf="isLayerActive(section.layerName)"
                                    [ngClass]="{'active': section.isActive}">
                                    <a (click)="activateSection(section)">{{section.title}}</a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>

                    <!-- Website -->
                    <ft-section name="website">
                        <div *ngIf="!propertyAdvocacyImpact.homepage && !isLayerLoaded('Homepage')"><div class="ft-loading-animation-dark">{{'flipto.account.Loading' | translate}} <span class="ft2-spinner"></span></div></div>
                        <div class="ft-contexttab-view active" *ngIf="!propertyAdvocacyImpact.homepage && isLayerLoaded('Homepage')">
                            Data currently unavailable.
                        </div>
                        <div class="ft-contexttab-view active ft-view-website" *ngIf="!!propertyAdvocacyImpact.homepage">
                            <p class="ft-stats-summary ft-text-plus-1">
                                {{ propertyAdvocacyImpact.homepage.totalVisitors | number }} site visitors viewed
                                your
                                <span class="ft-text-block">Homepage Component.</span>
                            </p>
                            <div class="ft-stats ft-hpc-stats">
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-clicks"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.homepage.totalVisitorsTookAction | number }}
                                    </div>
                                    <div class="ft-count-label">interacted with HPC</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-leads"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.homepage.totalCertificateSignups | number }}
                                    </div>
                                    <div class="ft-count-label">became a warm lead</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-bookings"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.homepage.totalDirectBookings | number }}
                                    </div>
                                    <div class="ft-count-label">started booking</div>
                                </div>
                            </div>
                        </div>
                    </ft-section>

                    <!-- Booking Engine -->
                    <ft-section name="bookingengine">
                        <div *ngIf="!propertyAdvocacyImpact.prestay && !isLayerLoaded('Pre-Stay')"><div class="ft-loading-animation-dark">{{'flipto.account.Loading' | translate}} <span class="ft2-spinner"></span></div></div>
                        <div class="ft-contexttab-view active" *ngIf="!propertyAdvocacyImpact.prestay && isLayerLoaded('Pre-Stay')">
                            Data currently unavailable.
                        </div>
                        <div class="ft-contexttab-view active ft-view-prestay" *ngIf="!!propertyAdvocacyImpact.prestay">
                            <p class="ft-stats-summary ft-text-plus-1">
                                {{ propertyAdvocacyImpact.prestay.totalAdvocates | number }} guests shared about
                                their upcoming stay soon after their booking.
                            </p>
                            <div class="ft-stats">
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-reach"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.prestay.totalSocialConnections | number }}
                                    </div>
                                    <div class="ft-count-label">people reached</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-visitors"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.prestay.totalVisitors | number }}
                                    </div>
                                    <div class="ft-count-label">site visitors attracted</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-leads"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.prestay.totalSignups | number }}
                                    </div>
                                    <div class="ft-count-label">warm leads earned</div>
                                </div>
                            </div>
                        </div>
                    </ft-section>

                    <!-- Story Builder (Post-stay + Invitations) -->
                    <ft-section name="poststay">
                        <div *ngIf="!propertyAdvocacyImpact.poststay && !isLayerLoaded('Post-Stay')"><div class="ft-loading-animation-dark">{{'flipto.account.Loading' | translate}} <span class="ft2-spinner"></span></div></div>
                        <div class="ft-contexttab-view active" *ngIf="!propertyAdvocacyImpact.poststay && isLayerLoaded('Post-Stay')">
                            Data currently unavailable.
                        </div>
                        <div class="ft-contexttab-view active ft-view-poststay" *ngIf="!!propertyAdvocacyImpact.poststay">
                            <p class="ft-stats-summary ft-text-plus-1">
                                {{(propertyAdvocacyImpact.poststay.totalSubmittedRating + propertyAdvocacyImpact.poststay.totalInvitees) | number}}
                                travelers participated.
                                <span *ngIf="propertyAdvocacyImpact.poststay.totalSubmittedRating > 0 || propertyAdvocacyImpact.poststay.totalInvitees > 0">
                                    *
                                </span>
                                Some provided genuine, rights-approved content:
                            </p>

                            <div class="ft-stats">
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-photos"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.poststay.totalSubmittedPhoto | number }}
                                    </div>
                                    <div class="ft-count-label">photos &amp; captions</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-quotes"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{propertyAdvocacyImpact.poststay.totalPositiveQuotes | number}}
                                    </div>
                                    <div class="ft-count-label">quotes</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-criticalfeedback"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{propertyAdvocacyImpact.poststay.totalNegativeQuotes | number}}
                                    </div>
                                    <div class="ft-count-label">notes for improvement</div>
                                </div>
                            </div>

                            <p class="ft-stats-summary ft-text-fineprint">
                                <span *ngIf="propertyAdvocacyImpact.poststay.totalSubmittedRating > 0 || propertyAdvocacyImpact.poststay.totalInvitees > 0">
                                    *
                                </span>
                                <span *ngIf="propertyAdvocacyImpact.poststay.totalInvitees > 0">{{propertyAdvocacyImpact.poststay.totalInvitees | number}}
                                    came from invitations.
                                </span>
                                <span *ngIf="propertyAdvocacyImpact.poststay.totalSubmittedRating > 0">
                                    {{propertyAdvocacyImpact.poststay.totalSubmittedRating | number}} came from
                                    post-stay process.
                                    <span>For the post-stay
                                        process {{propertyAdvocacyImpact.poststay.totalSentEmails | number}} emails
                                        were sent, of
                                        which {{propertyAdvocacyImpact.poststay.totalViewedEmails | number}} were
                                        viewed and {{propertyAdvocacyImpact.poststay.totalClickedEmails | number}}
                                        clicked
                                        ({{(propertyAdvocacyImpact.poststay.totalClickedEmails * 100 / propertyAdvocacyImpact.poststay.totalSentEmails) | number:'1.0-0'}}
                                        % CTR).
                                    </span>
                                </span>
                            </p>
                        </div>
                    </ft-section>

                    <!-- Photo Contest -->
                    <ft-section name="photoAdvocacy">
                        <div *ngIf="!propertyAdvocacyImpact.photoAdvocacy && !isLayerLoaded('Photo Contest')"><div class="ft-loading-animation-dark">{{'flipto.account.Loading' | translate}} <span class="ft2-spinner"></span></div></div>
                        <div class="ft-contexttab-view active" *ngIf="!propertyAdvocacyImpact.photoAdvocacy && isLayerLoaded('Photo Contest')">
                            Data currently unavailable.
                        </div>
                        <div class="ft-contexttab-view active ft-view-photo" *ngIf="!!propertyAdvocacyImpact.photoAdvocacy">
                            <p class="ft-stats-summary ft-text-plus-1">
                                {{ propertyAdvocacyImpact.photoAdvocacy.totalFinalists | number }} storytellers
                                <span *ngIf="!!propertyAdvocacyImpact.photoAdvocacy.totalFriendAdvocates">
                                    and {{ propertyAdvocacyImpact.photoAdvocacy.totalFriendAdvocates | number }}
                                    friends
                                </span>
                                shared their stories.*
                            </p>
                            <div class="ft-stats">
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-reach"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.photoAdvocacy.totalFollowers | number }}
                                    </div>
                                    <div class="ft-count-label">people reached</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-visitors"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.photoAdvocacy.totalVisitors | number }}
                                    </div>
                                    <div class="ft-count-label">unique site visitors</div>
                                </div>
                                <div class="ft-stat">
                                    <div class="ft-icn-bullet-leads"></div>
                                    <div class="ft-count ft-text-plus-5">
                                        {{ propertyAdvocacyImpact.photoAdvocacy.totalSignups | number }}
                                    </div>
                                    <div class="ft-count-label">warm leads</div>
                                </div>
                            </div>
                            <p class="ft-stats-summary ft-text-fineprint">
                                * Data gathered
                                from {{propertyAdvocacyImpact.photoAdvocacy.contests?.length | number }} campaigns
                                that were running during
                                this {{(endDate || snapshotEnd) | daysUntilDate:(startDate || snapshotStart) }}-day period.
                            </p>
                        </div>
                    </ft-section>
                </div>
            </section>
        </ft-sections>

    </section>
</ft-initialized-content>
